//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconFileAddFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M14 8V2H4V22H20V8H14ZM16 15H13V18H11V15H8V13H11V10H13V13H16V15Z" fill="currentColor" /><path d="M15.5 2.09003V6.50003H19.91L15.5 2.09003Z" fill="currentColor" /></svg>;
}
export default IconFileAddFill;